import { render } from "./SubMenuNode.vue?vue&type=template&id=003714aa&scoped=true"
import script from "./SubMenuNode.vue?vue&type=script&lang=js"
export * from "./SubMenuNode.vue?vue&type=script&lang=js"

import "./SubMenuNode.vue?vue&type=style&index=0&id=003714aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003714aa"]])

export default __exports__